import styled from 'styled-components';

import media from '@/styles/media.style';

export const Content = styled.div`
  ${media.tabletL`
    padding: 0 40px;
  `};

  ${media.desktop`
    padding: 0;
  `};
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.2px;
  margin-bottom: 20px;

  ${media.tabletL`
    font-size: 32px;
    line-height: 1.19;
    margin-bottom: 40px;
    margin-right: ${({ marginRight }) => marginRight};
    width: ${({ orientation }) => orientation};
  `};
`;

export const VerticalDescription = styled.div`
  ${media.tabletL`  
    column-count: 2;
    column-gap: 50px;
  `};

  ul {
    padding-left: 20px;

    ${media.tabletL`
      padding-left: 0;
    `};
  }

  li {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.1px;
    margin-bottom: 15px;

    ${media.tabletL`  
      font-size: 18px;
      line-height: 1.33;
    `};
  }

  p {
    margin: 0;
  }
`;

export const HorizontalDescription = VerticalDescription.extend`
  ${media.tabletL`  
    column-count: 1;
    width: 50%;
  `};
`;

export const PlaneDescription = VerticalDescription.extend`
  ${media.tabletL`  
    column-count: 1;
    width: 100%;
  `};
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${media.tabletL`
    flex-direction: ${({ orientation }) => (orientation === 'Horizontal' ? 'row' : 'column')};
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Article/TextSection.style.js